import { useNavigate } from "react-router-dom";

export default function ImportOptions({ appState, updateState }) {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/password-setup");
  };

  return (
    <div className="screen">
      <button className="back-button" onClick={handleBack}>
        ←
      </button>

      <div className="progress-dots">
        <div className="dot completed"></div>
        <div className="dot completed"></div>
        <div className="dot completed"></div>
        <div className="dot active"></div>
        <div className="dot"></div>
      </div>

      <h1 className="title">Import Wallet</h1>
      <p className="subtitle">Choose how you want to import your wallet</p>

      <div className="import-options">
        <button className="import-option" onClick={() => navigate("/recovery-phrase-import")}>
          <span className="import-icon-text">📝</span>
          <span className="import-text">Recovery phrase (12 or 24 words)</span>
          <span className="import-arrow">→</span>
        </button>

        <button className="import-option" onClick={() => navigate("/private-key-import")}>
          <span className="import-icon-text">🔑</span>
          <span className="import-text">Private key</span>
          <span className="import-arrow">→</span>
        </button>
      </div>
    </div>
  );
}